// Mock data for Better Lux Lawn Mowing landing page
// This will be replaced with real backend data later

export const mockServices = [
  {
    id: 1,
    title: "Lawn Mowing & Maintenance",
    description: "Professional mowing with precision striping. Regular maintenance keeps your lawn looking pristine year-round.",
    icon: "Scissors"
  },
  {
    id: 2,
    title: "Edging & Trimming",
    description: "Clean, crisp edges that define your property. Detailed trimming around obstacles and borders.",
    icon: "Ruler"
  },
  {
    id: 3,
    title: "Yard Cleanups",
    description: "Seasonal cleanups, debris removal, and yard preparation. Leave the mess to us.",
    icon: "Trash2"
  },
  {
    id: 4,
    title: "Recurring Service Plans",
    description: "Weekly or bi-weekly scheduled service. Never worry about your lawn again.",
    icon: "Calendar"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Langley",
    rating: 5,
    text: "Better Lux transformed our lawn into the best on the block. Professional, punctual, and detail-oriented. Highly recommend!",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Robert Chen",
    location: "Freeland",
    rating: 5,
    text: "Outstanding service! They show up on time, do meticulous work, and the results speak for themselves. Worth every penny.",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Jennifer Walsh",
    location: "Clinton",
    rating: 5,
    text: "Finally found a lawn service I can trust. Consistent quality, fair pricing, and they truly care about the details.",
    date: "3 weeks ago"
  }
];

// Real project images from Better Lux Lawn Mowing
export const projectGallery = [
  {
    id: 1,
    title: "Waterfront Estate - Precision Striping",
    image: "/images/premium-lawn-1.jpg",
    alt: "Premium waterfront lawn care with perfect striping by Better Lux Works in South Whidbey Island",
    description: "Stunning oceanfront property with expert lawn maintenance"
  },
  {
    id: 2,
    title: "Waterfront Property - Professional Maintenance",
    image: "/images/premium-lawn-2.jpg",
    alt: "Professional lawn mowing with precision striping on waterfront property in South Whidbey Island by Better Lux Works",
    description: "Pristine lawn maintenance with perfect striping patterns"
  },
  {
    id: 3,
    title: "Residential Lawn Care - Detail Work",
    image: "/images/hero-lawn-1.jpg",
    alt: "Detailed lawn mowing and edging service in South Whidbey Island by Better Lux Works",
    description: "Clean edges and professional mowing for island homes"
  },
  {
    id: 4,
    title: "Front Yard Excellence",
    image: "/images/project-1.jpg",
    alt: "Luxury lawn care service with striped mowing pattern in South Whidbey Island by Better Lux Works",
    description: "Beautiful front yard with expert lawn maintenance"
  },
  {
    id: 5,
    title: "Oceanfront Lawn Perfection",
    image: "/images/project-2.jpg",
    alt: "Premium oceanfront lawn mowing and maintenance in South Whidbey Island by Better Lux Works",
    description: "Impeccable lawn care for waterfront properties"
  },
  {
    id: 6,
    title: "Island Living - Lawn Excellence",
    image: "/images/hero-main.jpg",
    alt: "High-end residential lawn care in South Whidbey Island by Better Lux Works",
    description: "Premium lawn service for South Whidbey Island residents"
  }
];

export const mockFAQs = [
  {
    id: 1,
    question: "How much does lawn mowing cost?",
    answer: "Pricing varies based on lawn size and service frequency. We offer competitive rates and can provide a free quote after seeing your property. Most residential lawns range from $40-80 per visit."
  },
  {
    id: 2,
    question: "How often should I schedule service?",
    answer: "Most homeowners prefer weekly service during peak growing season (spring/summer) and bi-weekly during slower months. We can customize a schedule that works for your lawn's needs."
  },
  {
    id: 3,
    question: "Do you service all of South Whidbey Island?",
    answer: "Yes! We proudly serve all areas of South Whidbey Island including Langley, Freeland, Clinton, and surrounding neighborhoods."
  },
  {
    id: 4,
    question: "What makes Better Lux different?",
    answer: "We focus on the details that matter. From precision striping to clean edges, we treat every lawn like it's our own. Our 5.0-star rating reflects our commitment to excellence."
  },
  {
    id: 5,
    question: "Do I need to be home during service?",
    answer: "No! Most of our clients aren't home during service. We'll take care of everything and leave your property looking immaculate."
  }
];

export const businessInfo = {
  name: "Better Lux Works",
  fullName: "Better Lux Works Lawn Service",
  phone: "253-334-5090",
  rating: 5.0,
  reviewCount: 47,
  location: "South Whidbey Island, Washington",
  serviceArea: "South Whidbey Island and nearby areas",
  coordinates: {
    lat: 47.9731,
    lng: -122.4857
  }
};

// Mock form submission function
export const submitContactForm = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Store in browser localStorage for demo purposes
  const existingLeads = JSON.parse(localStorage.getItem('betterLuxLeads') || '[]');
  const newLead = {
    ...formData,
    id: Date.now(),
    submittedAt: new Date().toISOString()
  };
  existingLeads.push(newLead);
  localStorage.setItem('betterLuxLeads', JSON.stringify(existingLeads));
  
  return {
    success: true,
    message: "Thank you! We'll contact you within 24 hours to discuss your lawn care needs."
  };
};
